import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useDeckGlMapStyles = makeStyles(({ palette, shape, shadows, spacing }) =>
  createStyles({
    deckGlMapTooltip: {
      marginTop: `-${spacing(2)}`,
      marginLeft: `-${spacing(2)}`,
      pointerEvents: 'auto',
      position: 'absolute',
      zIndex: 9999,
    },
    geoJsonInnerMapTooltip: {
      color: palette.text.primary,
      backgroundColor: palette.background.paper,
      borderRadius: shape.borderRadius,
      boxShadow: shadows[3],
      padding: spacing(3),
      paddingTop: spacing(1),
      marginTop: spacing(),
      marginLeft: spacing(),
      '& *': {
        color: palette.text.primary,
      },
    },
    innerMapTooltip: {
      marginTop: spacing(2),
      marginLeft: spacing(2),
      position: 'relative',
    },
  })
);

export default useDeckGlMapStyles;
